import { ZustandConfigurationStore } from './types';

export const getWebConfigurationSelector = (state: ZustandConfigurationStore) =>
  state.webConfiguration;

export const getColorsSelector = (state: ZustandConfigurationStore) =>
  state.colors;

export const getVersionSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.version;

export const getTournamentsBannersSelector = (
  state: ZustandConfigurationStore
) => getWebConfigurationSelector(state)?.tournamentsBanners;

export const getBonusCardsSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.bonusImagePaths;

export const getBannerPathSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.bannersPath;

export const getMobileAppsInfoSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.apps;

export const getSocketTransportInfoSelector = (
  state: ZustandConfigurationStore
) => getWebConfigurationSelector(state)?.transport;

export const getBaseSocketUrlSelector = (state: ZustandConfigurationStore) =>
  getSocketTransportInfoSelector(state)?.address;

export const getBaseSocketForBettingFrameSelector = (
  state: ZustandConfigurationStore
) =>
  getSocketTransportInfoSelector(state)?.address?.replace('/casino', '') || '';

export const getSupportInfoSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.support;

export const getRegistrationInfoSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.registration;

export const getGoogleAuthInfoSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.registration.googleAuth;

export const getSupportMailSelector = (state: ZustandConfigurationStore) =>
  getSupportInfoSelector(state)?.mail;

export const getLanguagesForSelectorsSelector = (
  state: ZustandConfigurationStore
) =>
  getLanguagesInfoSelector(state)?.map((l, inx) => ({
    label: l.shortName,
    value: +inx,
  })) || [];

export const getDocsSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.docs;

export const getSocialInfoSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.social;

export const getLanguagesInfoSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.languages;

export const getKYCLinkSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.KYCLink;

export const getPartnersLinkSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.partnersUrl;

export const getSpecTranslateKeysSelector = (
  state: ZustandConfigurationStore
) => getWebConfigurationSelector(state)?.translateSpecialKeys;

export const getBettingInfoSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.betting;

export const getLicenseInfosSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.license;

export const isAvailableBettingSelector = (state: ZustandConfigurationStore) =>
  getBettingInfoSelector(state)?.isBetting;

export const isFrameBettingSelector = (state: ZustandConfigurationStore) =>
  getBettingInfoSelector(state)?.isFrame;

export const getBettingFrameUrlSelector = (state: ZustandConfigurationStore) =>
  getBettingInfoSelector(state)?.frameDomain;

export const getAdditionalCategoryInfoSelector = (
  state: ZustandConfigurationStore
) => {
  const config = getWebConfigurationSelector(state);

  return config?.categories || null;
};

// Path

export const getPromotionUrlSelector = (state: ZustandConfigurationStore) =>
  getWebConfigurationSelector(state)?.promotion;

const getPromotionSelector = (state: ZustandConfigurationStore) => ({} as any);

export const getPromotionPathSelector = (state: ZustandConfigurationStore) =>
  getPromotionSelector(state)?.path;

export const getPromotionBannerPropsSelector = (
  state: ZustandConfigurationStore
) => getPromotionSelector(state)?.banner;

export const getPromotionGiveAwayResultsPropsSelector = (
  state: ZustandConfigurationStore
) => getPromotionSelector(state)?.giveAwayResults;

export const getPromotionStepsSelector = (state: ZustandConfigurationStore) =>
  getPromotionSelector(state)?.step;

export const getPromotionGivesSelector = (state: ZustandConfigurationStore) =>
  getPromotionSelector(state)?.give;
export const getGiveAwayDrawDateSelector = (state: ZustandConfigurationStore) =>
  getPromotionSelector(state)?.drawDate;
export const getBigGiveAwayVideoSelector = (state: ZustandConfigurationStore) =>
  getPromotionSelector(state)?.video;

// ==================================== ACTIONS ====================================

export const getWebConfigurationAction = (state: ZustandConfigurationStore) =>
  state.getWebConfiguration;
